<template>
  <div class="price-box" v-if="orderData">
    <div class="commonbox">
      <div>{{ $t("message.order.totalPrice") }}</div>
      <div>
        {{ orderData.totalAmountMoney?`${orderData.totalAmountMoney.symbol}${$currencyFormatter(orderData.totalAmountMoney.number)}`:''
        }}
      </div>
    </div>
    <div class="commonbox" v-if="orderData.disCustAmountMoney">
      <!-- 卖家改价金额 -->
      <div>{{ $t("message.order.sellerModified") }}</div>
      <div>
        -{{ orderData.disCustAmountMoney?`${orderData.disCustAmountMoney.symbol}${$currencyFormatter(orderData.disCustAmountMoney.number)}`:'' 
        }}
      </div>
    </div>
      <div class="commonbox" v-if="orderData.allTaxAmountMoney && orderData.allTaxAmountMoney.number!=0">
      <!-- 税 -->
      <div>{{ $t("message.order.localTax") }}</div>
      <div>
        {{ orderData.allTaxAmountMoney?`${orderData.allTaxAmountMoney.symbol}${$currencyFormatter(orderData.allTaxAmountMoney.number)}`:'' 
        }}
      </div>
    </div>

  <div class="commonbox" v-if="orderData.freightAmountMoney && orderData.freightAmountMoney.number!=0">
    <!-- 运费 -->
      <div>{{ $t("message.order.postage") }}</div>
      <div>
        {{ orderData.freightAmountMoney?`${orderData.freightAmountMoney.symbol}${$currencyFormatter(orderData.freightAmountMoney.number)}`:'' 
        }}
      </div>
    </div>
    <!-- serviceFee 平台服务费 -->
    <div class="commonbox" v-if="orderData.orderServiceFeeInfo && orderData.orderServiceFeeInfo.serviceFeeAmountMoney && checkValue(orderData.orderServiceFeeInfo.serviceFeeAmountMoney.number)">
      <div class="service-fee global_pointer">
        <span>{{ $t("message.order.serviceFee") }}</span>
        <img src="https://fr-static.shopshops.top/20220713/service-fee.0207d37433af11f5.png" alt="" @click="showServiceFee">
      </div>
      <div>
        {{ orderData.orderServiceFeeInfo.serviceFeeAmountMoney.symbol}}{{ $priceSeparator( Number( orderData.orderServiceFeeInfo.serviceFeeAmountMoney.number ).toFixed(2) ) }}
      </div>
    </div>

    <div class="commonbox"  v-if="orderData.disTicketAmountMoney && checkValue(orderData.disTicketAmountMoney.number)">
       <!-- 优惠券 -->
      <div>{{ $t("message.order.coupon") }}</div>
      <div>
        -{{ orderData.disTicketAmountMoney?`${orderData.disTicketAmountMoney.symbol}${$currencyFormatter(orderData.disTicketAmountMoney.number)}`:'' 
        }}
      </div>
    </div>

    <div class="commonbox"  v-if="orderData.couponcodeSavePriceMoney && checkValue(orderData.couponcodeSavePriceMoney.number) ">
       <!-- 优惠码 -->
      <div>{{ $t("message.order.enterCode") }}</div>
      <div>
        -{{ orderData.couponcodeSavePriceMoney?`${orderData.couponcodeSavePriceMoney.symbol}${$currencyFormatter(orderData.couponcodeSavePriceMoney.number)}`:'' 
        }}
      </div>
    </div>

    <div class="commonbox"  v-if=" orderData.disRankAmountMoney && checkValue(orderData.disRankAmountMoney.number) ">
       <!-- vip折扣 -->
      <div>{{ $t("message.order.vipClass") }}</div>
      <div>
        -{{ orderData.disRankAmountMoney?`${orderData.disRankAmountMoney.symbol}${$currencyFormatter(orderData.disRankAmountMoney.number)}`:'' 
        }}
      </div>
    </div>
  
  </div>
</template>

<script>
import { Dialog } from 'vant'
export default {
    components: {
        [Dialog.name]: Dialog
    },
    props: {
        orderData: {
            type: Object,
            default() {
                return null;
            },
        },
    },
    data() {
        return {
            orderLan: this.$t("message.order")
        };
    },
    methods: {
       checkValue(str){
            return str ? str - 0 : 0
        },
        showServiceFee() {
            Dialog.alert({
                title: this.$t("message.order.serviceFee"),
                message: this.orderData.orderServiceFeeInfo.serviceFeeTitle,
                confirmButtonText: this.$t('message.goods.confirm'),
                confirmButtonColor: '#333333'
            }).then(() => {
            // on close
            });
        }
    }
};
</script>

<style lang="less" scoped>
.price-box {
  background: #fff;
  margin-top: 1px;
    padding: 3px 12px;
  font-family: "TradeGothicLT";
  .commonbox {
    display: flex;
    font-size: 13px;
    color: #5a5a5a;
    div {
      margin: 6px 0;
      text-align: left;
    }
    div:nth-child(1) {
      flex: 1;
    }
    .service-fee{
        display: flex;
        align-items: center;
        img{
            width: 16px;
            height: 16px;
            margin-left: 5px;
            vertical-align: top;
        }
    }
  }
}
</style>
